<template>
	<a-dialog class="not-found">
		<h1>{{ $t("title") }}</h1>
		<p class="not-found__body">{{ $t("body") }}</p>
		<div v-if="hasTenant" slot="actions" class="not-found__button-container">
			<a-button
				:to="{ name: 'home' }"
				secondary
				class="not-found__button"
			>
				{{ $t("backHome") }}
			</a-button>
			<a-button class="not-found__button" @click="$router.go(-1)">
				{{ $t("backPrevious") }}
			</a-button>
		</div>
	</a-dialog>
</template>

<script>
import aDialog from "@/components/Dialog";
import aButton from "@/components/Button";
import store from "@/store";

export default {
	components: {
		aDialog,
		aButton
	},
	computed: {
		hasTenant() {
			return store.getters.loaded;
		}
	},
	i18n: {
		messages: {
			en: {
				title: "Hmm, we couldn’t find that page",
				body:
					"Please try returning to the previous page or go back to our homepage. We are sorry for the inconvenience.",
				backHome: "Back to homepage",
				backPrevious: "Previous page"
			},
			nl: {
				title: "Hmm, we konden deze pagina niet vinden",
				body:
					"Probeer de pagina te vernieuwen of ga terug naar de startpagina. Onze excuses voor het ongemak.",
				backHome: "Terug naar startpagina",
				backPrevious: "Vorige pagina"
			}
		}
	}
};
</script>

<style lang="scss">
.not-found {
	width: 680px;
}
.not-found__body {
	margin: 0;
}
.not-found__button:last-child {
	margin-left: 15px;
}

@media only screen and (max-width: $mobile-breakpoint) {
	.not-found__button-container {
		display: flex;
		flex-direction: column;
		width: 100%;
	}
	.not-found__button:last-child {
		margin: 15px 0 0 0;
	}
}
</style>
